import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import "./App.scss";

import Home from "./pages/Home";
import Navbar from "./components/Navigation/Navbar";
import Footer from "./components/Footer/Footer";
import AdminLogin from "./pages/AdminLogin";
import Order from "./pages/Order";
import Logout from "./Auth/Logout";
import AdminPanel from "./pages/AdminPanel";
import OrderForm from "./pages/OrderForm";

function App({ loggedIn, cart }) {
    let routes;

    // Conditional Route render
    const renderFormOrderRoute = () => {
        if (cart && cart.length >= 1) {
            return <Route exact path="/orderForm" component={OrderForm} />;
        } else {
            return null;
        }
    };

    if (loggedIn !== undefined) {
        routes = (
            <Switch>
                {/* <Route exact path="/" component={Home} />
                <Route exact path="/order" component={Order} /> */}
                <Route exact path="/adminPanel" component={AdminPanel} />
                <Route exact path="/logout" component={Logout} />
                <Redirect to="/adminPanel" />
            </Switch>
        );
    } else {
        routes = (
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/order" component={Order} />
                {renderFormOrderRoute()}
                <Route exact path="/adminLogin" component={AdminLogin} />
                <Redirect to="/" />
            </Switch>
        );
    }

    return (
        <div className="App">
            <Navbar loggedIn={loggedIn} />
            {routes}
            <Footer />
        </div>
    );
}

const mapStateToProps = ({ firebase, menu }) => ({
    loggedIn: firebase.auth.uid,
    cart: menu.cart
});

export default connect(mapStateToProps)(App);
